export default {
  howItWorks: {
    id: 'swap_block_cart_how_it_works',
    defaultMessage: 'How it works',
  },
  swapTitle: {
    id: 'swap_block_cart_title',
    defaultMessage: 'Got a device to trade in?',
  },
  swapSubtitle: {
    id: 'swap_block_cart_subtitle',
    defaultMessage:
      'Offset your total cart by a pretty penny when you trad in an old device.',
  },
  getSwapEstimation: {
    id: 'swap_block_cart_cta',
    defaultMessage: 'See trade-in value',
  },
  swapIntroduction: {
    id: 'swap_block_cart_introduction',
    defaultMessage: 'Save on today’s purchase',
  },
}
